import { Formik } from "formik";
import { ArtFieldMetadataProvider } from "./artFieldMetadataContext";
import FormikFocusError from "./formikFocusError";

const FormikForm = ({ children, artFields, ...props }) => {

  return (
    <Formik {...props}>
      {(formikProps) => (
        <ArtFieldMetadataProvider fields={artFields}>
          <>
            <FormikFocusError />
            {typeof children === "function" ? children(formikProps) : children}
          </>
        </ArtFieldMetadataProvider>
      )}
    </Formik>
  )

}

export default FormikForm;